import Vue from "vue";
import Vuex from "vuex";
import { dsv, json } from "d3-fetch";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    indicators: [],
    mapping: {}, //mapping from gemeente to deelregio
    //data_gemeenten: null,
    data_deelregios: {},
    geo: null,
    thema: null,
    pijler: null,
    indicator: null,
    indicator2: null,
    normalization: "",
    aggregation: "", //"gemeente" or "deelregio"
    values: {},
    values2: {}
  },
  getters: {
    indicators: state => state.indicators,
    mapping: state => state.mapping,
    //data_gemeenten: state => state.data_gemeenten,
    data_deelregios: state => state.data_deelregios,
    geo: state => state.geo,
    thema: state => state.thema,
    pijler: state => state.pijler,
    indicator: state => state.indicator,
    indicator2: state => state.indicator2,
    normalization: state => state.normalization,
    aggregation: state => state.aggregation,
    values: state => state.values,
    values2: state => state.values2
  },
  mutations: {
    SET_INDICATORS: (state, payload) => {
      state.indicators = payload;
    },
    SET_MAPPING: (state, payload) => {
      state.mapping = payload;
    },
    // SET_DATA_GEMEENTEN: (state, payload) => {
    //   state.data_gemeenten = payload;
    // },
    SET_DATA_DEELREGIOS: (state, payload) => {
      state.data_deelregios = payload;
    },
    SET_GEO: (state, payload) => {
      state.geo = payload;
    },
    SET_THEMA: (state, payload) => {
      state.thema = payload;
    },
    SET_PIJLER: (state, payload) => {
      state.pijler = payload;
    },
    SET_INDICATOR: (state, payload) => {
      state.indicator = payload;
    },
    SET_INDICATOR2: (state, payload) => {
      state.indicator2 = payload;
    },
    SET_NORMALIZATION: (state, payload) => {
      state.normalization = payload;
    },
    SET_AGGREGATION: (state, payload) => {
      state.aggregation = payload;
    },
    SET_VALUES: (state, payload) => {
      state.values = payload;
    },
    SET_VALUES2: (state, payload) => {
      state.values2 = payload;
    }
  },
  actions: {
    readData: context => {
      //read indicators
      dsv(";", `${process.env.VUE_APP_DATA_DIR}data/toelichting.csv`).then(
        data => {
          context.commit("SET_INDICATORS", data);
        }
      );
      //read mapping from gemeenten to deelregio's
      dsv(";", `${process.env.VUE_APP_DATA_DIR}data/mapping.csv`).then(rows => {
        //create lookup table
        const mapping = {};
        rows.forEach(r => {
          mapping[r.GMN_NAAM19] = r.MRA_DEELREGIO;
        });
        context.commit("SET_MAPPING", mapping);
      });
      dsv(";", `${process.env.VUE_APP_DATA_DIR}data/data_deelregios.csv`).then(
        rows => {
          //create lookup table
          const data = {};
          rows.forEach(r => {
            //replace ',' with '.' (in floats)
            for (const [key, value] of Object.entries(r)) {
              r[key] = value.replaceAll(",", ".");
            }
            data[r.MRA_DEELREGIO] = r;
          });
          context.commit("SET_DATA_DEELREGIOS", data);
          context.dispatch("updateValues");
        }
      );
      //read geometry
      json(`${process.env.VUE_APP_DATA_DIR}data/geo.json`).then(data => {
        context.commit("SET_GEO", data);
      });
    },
    updateIndicator: (context, newIndicator) => {
      context.commit("SET_INDICATOR", newIndicator);
      context.dispatch("updateValues");
    },
    updateIndicator2: (context, newIndicator) => {
      context.commit("SET_INDICATOR2", newIndicator);
      context.dispatch("updateValues");
    },
    updateNormalization: (context, newNormalization) => {
      context.commit("SET_NORMALIZATION", newNormalization);
      context.dispatch("updateValues");
    },
    updateAggregation: (context, newAggregation) => {
      context.commit("SET_AGGREGATION", newAggregation);
      context.dispatch("updateValues");
    },
    updateValues: context => {
      //if (context.getters.data_deelregios && context.getters.data_gemeenten) {
      if (context.getters.data_deelregios) {
        const indicator = context.getters.indicator;
        const indicator2 = context.getters.indicator2;
        const normalization = context.getters.normalization;

        const data = context.getters.data_deelregios;

        let values = {};
        if (indicator) {
          for (const [key, valueList] of Object.entries(data)) {
            const value = parseFloat(valueList[indicator.variabele]);
            const nrInhabitants = parseFloat(
              valueList[indicator["veld aantal inwoners"]]
            );
            if (normalization == "perInhabitant") {
              values[key] = value / nrInhabitants;
            } else if (normalization == "per1000") {
              values[key] = (1000 * value) / nrInhabitants;
            } else {
              values[key] = Math.round(value * 10) / 10;
            }
          }
        }
        context.commit("SET_VALUES", values);

        let values2 = {};
        if (indicator2) {
          for (const [key, valueList] of Object.entries(data)) {
            const value = parseFloat(valueList[indicator2.variabele]);
            const nrInhabitants = parseFloat(
              valueList[indicator["veld aantal inwoners"]]
            );
            if (normalization == "perInhabitant") {
              values2[key] = value / nrInhabitants;
            } else if (normalization == "per1000") {
              values2[key] = (1000 * value) / nrInhabitants;
            } else {
              values2[key] = Math.round(value * 10) / 10;
            }
          }
        }
        context.commit("SET_VALUES2", values2);
      }
    }
  }
});
